import React, { useEffect, useState } from 'react';
import MaintenanceScreen from '@/components/MaintenanceScreen';
import { getParametroTexto } from '@/services/getParametroTexto';
import { isAuthenticated } from '@/utils/auth';

interface MaintenanceGateProps {
  children: React.ReactNode;
}

const MaintenanceGate: React.FC<MaintenanceGateProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [maintenanceText, setMaintenanceText] = useState('');

  useEffect(() => {
    const checkMaintenance = async () => {
      // Only check maintenance mode if user is authenticated
      // This prevents 401 errors on public pages like activation
      if (!isAuthenticated()) {
        setIsLoading(false);
        return;
      }

      try {
        const resp = await getParametroTexto({
          nombre: 'Sitio_En_Mantenimiento_Switch',
        });
        if (resp === 'SI') {
          setIsMaintenance(true);
          const textResp = await getParametroTexto({
            nombre: 'Sitio_En_Mantenimiento_Switch_Texto',
          });
          setMaintenanceText(textResp);
        }
      } catch (e) {
        // Si hay error, por seguridad, dejar pasar a la app
      } finally {
        setIsLoading(false);
      }
    };
    checkMaintenance();
  }, []);

  if (isLoading) return null;
  if (isMaintenance) return <MaintenanceScreen text={maintenanceText} />;
  return children;
};

export default MaintenanceGate;
